import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  GetVideoGameRatingsResp,
  VideoGameRatingDto,
  VideoGameRatingModel,
} from '../types/video-game-rating'

export const transformVideoGameRatingDto = (
  videoGameRating: VideoGameRatingDto,
): VideoGameRatingModel => {
  const { id, title } = videoGameRating

  return {
    id,
    title,
  }
}

export const transformVideoGameRatingDtos = (
  videoGameRatings: Array<VideoGameRatingDto>,
): Array<VideoGameRatingModel> => videoGameRatings.map(transformVideoGameRatingDto)

export const transformGetVideoGameRatingResponse = (
  response: Response<GetVideoGameRatingsResp>,
): Array<VideoGameRatingModel> => transformVideoGameRatingDtos(response.video_game_ratings)
